export default __webpack_public_path__ + "static/media/M4MHowItWorks.d6d69aa4.png";